import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import OffreItem from 'components/OffresBlock/Item';
import messages from 'components/OffresBlock/messages';
import { OffreItemProp } from 'components/OffresBlock/types';
import {
  OFFER_ADVICE_ADE_LINK,
  OFFER_ADVICE_MRH_LINK,
  OFFER_ADVICE_NEW_BUSINESS_LINK,
  OFFER_ADVICE_RENEW_LINK,
} from 'constants/externalLinks';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import { AssuranceIcon } from 'images';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import { getLocale } from 'store/LanguageProvider/selectors';
import { StyledCarouselContainer } from './style';

const OffreBlock = () => {
  const language = useSelector(getLocale);
  const { formatMessage } = useIntl();

  const items: OffreItemProp[] = [
    {
      backgroundImage: AssuranceIcon.renewAuto,
      title: formatMessage({ ...messages.renewAutoTitle }),
      body: formatMessage({ ...messages.renewAutoContent }),
      ctaText: formatMessage({ ...messages.buttonLabel_make_estimate }),
      link: OFFER_ADVICE_RENEW_LINK[language],
      category: EVENT_CATEGORIES.OFFRES_CONSEILS,
      label: 'Renouvellement_Obtenir un devis',
    },
    {
      backgroundImage: AssuranceIcon.newBusiness,
      title: formatMessage({ ...messages.newBusinessTitle }),
      body: formatMessage({ ...messages.newBusinessContent }),
      ctaText: formatMessage({ ...messages.buttonLabel_make_estimate }),
      link: OFFER_ADVICE_NEW_BUSINESS_LINK[language],
      category: EVENT_CATEGORIES.OFFRES_CONSEILS,
      label: 'Nouvelle affaire_Obtenir un devis',
    },
    {
      backgroundImage: AssuranceIcon.offerMRH,
      title: formatMessage({ ...messages.offerMRHTitle }),
      body: formatMessage({ ...messages.offerMRHContent }),
      ctaText: formatMessage({ ...messages.buttonLabel_make_estimate }),
      link: OFFER_ADVICE_MRH_LINK[language],
      category: EVENT_CATEGORIES.OFFRES_CONSEILS,
      label: 'MRH_Obtenir un devis',
    },
    {
      backgroundImage: AssuranceIcon.ADE,
      title: formatMessage({ ...messages.ADETitle }),
      body: formatMessage({ ...messages.ADEContent }),
      ctaText: formatMessage({ ...messages.buttonLabel_make_estimate }),
      link: OFFER_ADVICE_ADE_LINK[language],
      category: EVENT_CATEGORIES.OFFRES_CONSEILS,
      label: 'ADE_Obtenir un devis',
    },
  ];

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const Parent = matches ? Carousel : Grid;
  const Container = matches ? StyledCarouselContainer : React.Fragment;

  return (
    <Box marginBottom={4}>
      <Container>
        <Parent
          {...(matches
            ? { className: 'direction' }
            : { container: true, justify: 'space-between' })}
        >
          {items &&
            items.map((item, index) => {
              return <OffreItem {...item} key={index}></OffreItem>;
            })}
        </Parent>
      </Container>
    </Box>
  );
};

export default OffreBlock;
